import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const Button = ({ children, circle, className, color, label, outline, size, tag: Tag, ...props }) => {
  const type = Tag === 'button' ? 'button' : null;
  const colorString = color ? `btn-${color}` : null;
  const sizeString = size ? `btn-${size}` : null;
  const outlineString = outline ? `btn-outline-${color}` : null;

  return (
    <Tag
      className={classnames(
        'btn',
        className,
        !outline && colorString,
        outlineString,
        sizeString,
        circle && 'btn-circle'
      )}
      data-testid="Button"
      type={type}
      aria-label={label}
      {...props}
    >
      {children}
    </Tag>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  circle: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.string,
  label: PropTypes.string.isRequired,
  outline: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 'sm', 'lg', 'xl']),
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

Button.defaultProps = {
  children: null,
  circle: false,
  className: null,
  color: null,
  outline: false,
  size: null,
  tag: 'button',
};

export default Button;
